var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Button } from '@leapfinance/geebee-component-library';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import { copyDetailsForCourseDetails } from '../../../geebee/cf/CfCourseCardUtil';
var CourseActionsSection = function (_a) {
    var courseData = _a.courseData, handleAddToShortlist = _a.handleAddToShortlist, handleDownloadCoursePdf = _a.handleDownloadCoursePdf, partnerName = _a.partnerName, onCopyDetailsClick = _a.onCopyDetailsClick;
    var _b = __read(useState(false), 2), copyState = _b[0], setCopyState = _b[1];
    return (React.createElement("div", { className: "lfc-bg-white lfc-my-4 lfc-p-4 lfc-rounded-lg" },
        React.createElement("div", { className: "lfc-flex lfc-justify-between lfc-items-center lfc-flex-col xl:lfc-flex-row lfc-gap-3" },
            React.createElement(Button, { fullWidth: true, variant: "tertiary", endIcon: React.createElement(ContentCopyRoundedIcon, null), className: "lfc-whitespace-nowrap lfc-min-w-fit ".concat(copyState ? 'lfc-bg-success-500 lfc-text-white' : ''), onClick: function () {
                    onCopyDetailsClick === null || onCopyDetailsClick === void 0 ? void 0 : onCopyDetailsClick();
                    copyDetailsForCourseDetails(setCopyState, { partnerName: partnerName }, courseData);
                } }, copyState ? 'Details Copied' : 'Copy Details'),
            React.createElement(Button, { variant: "secondary", startIcon: React.createElement(SaveAltRoundedIcon, null), onClick: handleDownloadCoursePdf, fullWidth: true, className: "lfc-whitespace-nowrap lfc-min-w-fit" }, "Download")),
        React.createElement(Button, { fullWidth: true, className: "lfc-mt-3", startIcon: React.createElement(AddRoundedIcon, null), onClick: handleAddToShortlist }, "Add to Shortlist")));
};
export default CourseActionsSection;
//# sourceMappingURL=CourseActionsSection.js.map